import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }

import { ref, computed } from 'vue'
import { useUserStore } from '@/stores/user'
import { ProfilePoupData } from './supportScript';
import ProfilePopupOne from '@/themes/themeOne/profile/profilePopup.vue';
import ProfilePopupTwo from '@/themes/themeTwo/profile/profilePopup.vue';
import { HOME_COMPONENT_ID } from '../home/supportScript';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'profilePopup',
  emits: ['openAgentPopup'],
  setup(__props, { expose: __expose, emit: __emit }) {

const userStore = useUserStore()
const themeStore = useThemeStore();
const componentIdsInOrderConfig = ref(HOME_COMPONENT_ID);
const show = ref(false)
const isPopping = ref(false)
const componentList = ref([])

const dataSet = computed<ProfilePoupData>(() => ({
    show: show.value,
    isPopping: isPopping.value,
    componentList: componentList.value,
    componentIdsInOrderConfig: componentIdsInOrderConfig.value,
}))

const open = (list: any) => {
    console.log('open');

    componentList.value = list
    show.value = true
    userStore.getInfo()
}
const emits = __emit
const close = () => {
    show.value = false
}
const clickBanner = () => {
    isPopping.value = true
    setTimeout(() => {
        isPopping.value = false
        emits('openAgentPopup')
    }, 300)

}

__expose({
    open,
    close
})


return (_ctx: any,_cache: any) => {
  const _directive_modal = _resolveDirective("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (show.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _withDirectives(_createVNode(ProfilePopupOne, {
                  "data-set": dataSet.value,
                  onClickBanner: clickBanner,
                  onClose: close
                }, null, 8, ["data-set"]), [
                  [_directive_modal, show.value]
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (show.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _withDirectives(_createVNode(ProfilePopupTwo, {
                  "data-set": dataSet.value,
                  onClickBanner: clickBanner,
                  onClose: close
                }, null, 8, ["data-set"]), [
                  [_directive_modal, show.value]
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})